export const generateMainContent = (data = {}) => {
  const backgroundUrl = data?.background.url || ''
  const title = data?.text?.content || ''
  const titleStyle = data?.text?.style || {}
  const text_1 = data?.default_coupon?.content || ''
  const text_1Style = data?.default_coupon?.style || {}
  const text_2 = data?.text_2?.content || ''
  const text_2Style = data?.text_2?.style || {}
  const email_style = data?.text_3?.style || {}
  const inputPlaceholder = data?.input?.content || ''
  const inputStyle = data?.input?.style || {}
  const buttonText = data?.button?.content || ''
  const buttonStyle = data?.button?.style || {}

  const html = `
  <div id="kariba_overlay_container">
    <div id="kariba_default_code" class="show-class"
      style="background: url(${backgroundUrl}) no-repeat;
      background-size: cover;
      background-position: center;"
    >
      <div id="kariba_input_container" class="kariba-default-code-container">
        <div id="kariba_close_default_code" class="k-m-close-button">
          <i class="material-icons">&#xe5cd;</i>
        </div>
        <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
                  color: ${titleStyle.color || '#FA541C'};
                  font-size: ${titleStyle.fontSize || 36}px;
                  font-weight: ${titleStyle.fontStyle || 'bold'};
                  text-align: ${titleStyle.textAlign || 'left'};
                  width:262px;
                  margin-bottom: 20px;
        ">${title}</span>
        <span style="font-family: ${text_1Style.fontFamily || 'Inter'}; 
          color: ${text_1Style.color || '#FA541C'};
          font-size: ${text_1Style.fontSize || 20}px;
          font-weight: ${text_1Style.fontStyle || 'bold'};
          text-align: ${text_1Style.textAlign || 'center'};
          width:262px;
          ">20%</span>
          
        <span style="font-family: ${text_2Style.fontFamily || 'Inter'}; 
          color: ${text_2Style.color || '#FA541C'};
          font-size: ${text_2Style.fontSize || 14}px;
          font-weight: ${text_2Style.fontStyle || 'bold'};
          text-align: ${text_2Style.textAlign || 'center'};
          margin-bottom: 15px;
          width:262px
          ">${text_2}</span>
        <input
            id='kariba_minigame_email'
            placeholder='${inputPlaceholder || 'Enter email'}'
            style="font-family: ${inputStyle.fontFamily || 'Inter'}; 
              color: ${inputStyle.color || '#000'};
              font-size: ${inputStyle.fontSize || 14}px;
              font-weight: ${inputStyle.fontStyle || 'nomal'};
              text-align: ${inputStyle.textAlign || 'center'};
              width:262px;
              height:40px;
              border-radius:4px;
              padding: 15px 10px;
              border: 1px solid rgba(0, 0, 0, 0.15);
              align-self: center;
              border: 1px solid #CCC;"
        />
        <div 
          id="alert_email" 
          style="display:none;
          font-family: ${email_style.fontFamily || 'Inter'};
          color: ${email_style.color || '#F5222D'};
          font-size: ${email_style.fontSize || 22}px;
          font-weight: ${email_style.fontStyle || 'normal'};
          text-align: ${email_style.textAlign || 'left'};
          width:262px">Email bạn nhập vào không hợp lệ</div>
        <button
          id="receive_voucher"
          style="font-family: ${buttonStyle.fontFamily || 'Inter'}; 
          background-color: ${buttonStyle.backgroundColor || '#FA541C'};
          color: ${buttonStyle.color || '#FFF'};
          font-size: ${buttonStyle.fontSize || 14}px;
          font-weight: ${buttonStyle.fontStyle || 'nomal'};
          text-align: ${buttonStyle.textAlign || 'center'};
          width:262px;
          height:40px;
          border-radius:4px;
          align-self: center;
          border: none;
          outline: none;
          margin: 15px 0px;
          font-weight:600;
          cursor: pointer"
        >${buttonText}</button>
        </div>
      </div>`

  return html
}
